<script>
import { mapState, mapActions } from 'vuex';
import ModalOverlay from '@/components/modal/ModalOverlay';
import Button from '@/components/Button';
import Simplebar from 'simplebar-vue';
import {} from '@/scripts/utils';

export default {
  name: 'TermsWrapper',
  components: {
    Button,
    ModalOverlay,
    Simplebar,
  },
  props: {
    show: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {};
  },
  computed: {
    ...mapState([]),
    // TODO: active button after user reed text or user scroll bottom block
    activeButton() {
      return !false;
    },
  },
  created() {},
  mounted() {},
  methods: {
    ...mapActions({}),
  },
};
</script>

<template>
  <ModalOverlay>
    <div class="modal__dialog">
      <div class="modal__content">
        <div class="modal__top">
          <span>Terms of Service</span>
          <div class="modal__close" @click="$emit('close')">
            <img :src="require('@/assets/svg/close.svg')" />
          </div>
        </div>
        <div class="modal__middle">
          <Simplebar data-simplebar-auto-hide="false" class="scroll">
            <!--  -->
            <slot></slot>
          </Simplebar>
        </div>
        <div class="modal__bottom">
          <Button
            class="blue lg-width"
            :disabled="!activeButton"
            @click="$emit('accept')"
          >
            Accept the Terms of service
          </Button>
        </div>
      </div>
    </div>
  </ModalOverlay>
</template>

<style scoped lang="scss">
@import '@/styles/variables.scss';
.modal {
  &__dialog {
    padding: 50px 20px 40px;
    height: 100%;
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  &__content {
    max-width: 970px;
    max-height: 100%;
    border-radius: 36px;
    background-color: #101112;
    padding: 0 0 30px;
    display: flex;
    flex-direction: column;
    width: 100%;

    font-family: Poppins-Regular;
    font-size: 14px;
    line-height: 23px;
    color: #ffffff;
  }

  &__top {
    display: flex;
    align-items: center;
    justify-content: center;
    text-align: center;
    position: relative;
    padding: 40px 30px;
    font-family: Poppins-Regular;
    font-size: 21px;
    line-height: 29px;
    color: #ffffff;
    flex-shrink: 0;
  }

  &__middle {
    flex-grow: 1;
    display: flex;
    overflow: hidden;
    padding: 0 15px 0 30px;

    .scroll {
      flex-grow: 1;
    }
  }

  &__bottom {
    flex-shrink: 0;
    display: flex;
    justify-content: center;
    border-top: solid 1px #979797;
    padding: 30px 30px 0;
    margin-top: 10px;
  }

  &__close {
    position: absolute;
    right: 25px;
    top: 25px;
    width: 12px;
    height: 12px;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: all 0.2s;
    cursor: pointer;

    img {
      display: flex;
      width: 100%;
      height: 100%;
    }

    &:hover {
      opacity: 0.5;
    }
  }

  &__wrapper {
    padding-right: 15px;
  }
}

@media (max-width: $mobile) {
  .modal {
    &__dialog {
      padding: 0;
    }

    &__content {
      border-radius: 0;
      padding-bottom: 20px;
    }

    &__top {
      padding: 25px 15px 20px;
      font-size: 18px;
      line-height: 25px;
    }

    &__close {
      top: 20px;
      right: 20px;
      width: 16px;
      height: 16px;
    }

    &__bottom {
      margin-top: 0;
      padding: 30px 15px 0;
      border: 0;
    }
  }
}
</style>
